import { render, staticRenderFns } from "./RallyInsure.vue?vue&type=template&id=0164fddf"
import script from "./RallyInsure.vue?vue&type=script&lang=ts"
export * from "./RallyInsure.vue?vue&type=script&lang=ts"
import style0 from "./RallyInsure.vue?vue&type=style&index=0&id=0164fddf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports